module.exports = __webpack_public_path__ + "static/img/ch_bcg.86442605.png";